import { render } from "./SkillsView.vue?vue&type=template&id=c539e9d2&scoped=true"
import script from "./SkillsView.vue?vue&type=script&lang=js"
export * from "./SkillsView.vue?vue&type=script&lang=js"

import "./SkillsView.vue?vue&type=style&index=0&id=c539e9d2&scoped=true&lang=css"

import exportComponent from "C:\\Development\\Portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c539e9d2"]])

export default __exports__